module.exports = __webpack_public_path__ + "img/connexion-people.c522e81f.png";